// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {injectIntl, intlShape} from 'react-intl';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';

function handleChange(event) {

    this.onChange(event.target.value);

}

const ReportLayoutDropDown = props =>
    <select
        className='report-layout-dropdown'
        onChange={props::handleChange}
        value={props.value}
    >
        {
            props.list.map((layout, index) => {

                const layoutName = layout.name === '' ?
                    props.intl.formatMessage({id: 'STANDARD_VIEW'}) :
                    layout.name;

                return (
                    <option
                        key={index}
                        value={layout.name}
                    >
                        {layoutName}
                    </option>
                );

            })
        }
    </select>;

ReportLayoutDropDown.displayName = 'ReportLayoutDropDown';
ReportLayoutDropDown.propTypes = {
    intl: intlShape.isRequired,
    list: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired
};

export default injectIntl(ReportLayoutDropDown);



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-layout-dropdown/index.js